import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('cta-hero');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show as soon as the first CTA has been scrolled past.
      setVisible(entry.boundingClientRect.top < 0);
    }, {
      threshold: 0,
      rootMargin: '0px'
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-32" data-mp="br2e14kk8t7t">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-spark-500/25 bg-ink-950/95 px-3 pb-[calc(0.6rem+env(safe-area-inset-bottom))] pt-2.5 backdrop-blur" data-id="element-33" data-mp="bq9hewfbfk3e">
          <a href={CHECKOUT_URL} className="mx-auto flex w-full max-w-md animate-shake items-center justify-center gap-2 rounded-xl bg-spark-500 px-4 py-3.5 font-display text-lg uppercase tracking-wide text-ink-950 shadow-[0_8px_24px_-6px_rgba(255,184,0,0.65)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-spark-400 sm:text-xl" data-id="element-34" data-mp="2f2zgdin2j2wu">
            <FlameIcon className="h-5 w-5" aria-hidden="true" data-id="element-35" data-mp="1wf43e0za5t4s" />
            Je veux le Système Maître — 19 €
          </a>
        </motion.div>}
    </AnimatePresence>;
}